import { useEffect, useState } from "react";
import { Button } from "@/components/ui/button";
import { Card } from "@/components/ui/card";
import { Link } from "react-router-dom";
import { Cookie } from "lucide-react";

export default function CookieBanner() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem("tuotax_cookie_consent");
    if (!consent) setVisible(true);
  }, []);

  const accept = () => {
    localStorage.setItem("tuotax_cookie_consent", "accepted");
    setVisible(true);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div className="fixed bottom-4 left-4 right-4 md:left-auto md:right-6 md:max-w-md z-40 fade-in-up" data-testid="cookie-banner">
      <Card className="p-4 md:p-5 rounded-2xl border-2 border-primary/20 shadow-2xl bg-card">
        <div className="flex items-start gap-3">
          <div className="w-9 h-9 md:w-10 md:h-10 rounded-xl bg-accent flex items-center justify-center flex-shrink-0">
            <Cookie className="w-4 h-4 md:w-5 md:h-5 text-primary" />
          </div>
          <div className="flex-1 min-w-0">
            <div className="font-heading font-semibold text-sm md:text-base mb-1">La tua privacy conta.</div>
            <p className="text-[11px] md:text-xs text-muted-foreground leading-relaxed line-clamp-3 md:line-clamp-none">
              TUOTAX usa solo cookie tecnici essenziali (autenticazione). Nessun tracking di terze parti.
              Vedi la <Link to="/privacy" className="text-primary font-semibold underline" data-testid="cookie-privacy-link">privacy policy</Link> o i <Link to="/terms" className="text-primary font-semibold underline" data-testid="cookie-terms-link">termini</Link>.
            </p>
            <Button onClick={accept} size="sm" className="rounded-full mt-2 md:mt-3 h-9" data-testid="cookie-accept">
              Ho capito
            </Button>
          </div>
        </div>
      </Card>
    </div>
  );
}
